// (c) 2024 ABBYY Development, Inc.

import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: row;
`;

export const Content = styled.div`
    width: 100%;
    padding: 0 10px;
`;
